<template lang="html">
  <footer id="footer">
    <section class="newsletter-section">
      <h2>¡Registra tu correo para recibir nuestras promociones!</h2>

      <b-form @submit.prevent="onSubmit">
        <b-form-group>
          <b-form-input
            v-model="form.email"
            type="email"
            required
            placeholder="Correo electrónico"
          ></b-form-input>
        </b-form-group>

        <b-button type="submit" class="btn-send">Enviar</b-button>
      </b-form>
    </section>

    <section class="footer-section">
      <div class="container oversized-container">
        <div class="row">
          <div class="col-6 col-lg col-footer">
            <h6>Matriz</h6>
            <p>
              Dr. Arturo Guerra No. 361,<br />
              Col. Braulio Maldonado, C.P. 21480,<br />
              Tecate, Baja California.
            </p>
          </div>

          <div class="col-6 col-lg col-footer">
            <h6>Teléfonos</h6>
            <p>
              <strong>Matriz:</strong> (665) 654 0301, (665) 654 1651, (800) 233 0043
            </p>
            <p class="mt-1">
              <strong>Tijuana:</strong> (664) 687 8023
            </p>
            <p class="mt-1">
              <strong>Call Center:</strong> (663) 203 1001
            </p>
          </div>

          <div class="col-lg col-logo">
            <router-link to="/">
              <img src="public/images/logo.png">
            </router-link>

            <p class="p-networks">
              <span>¡Síguenos!</span>
              <a class="trans-150" target="_blank" href="https://www.facebook.com/mfdoit"><i class="fab fa-facebook-square"></i></a>
              <a class="trans-150" target="_blank" href="https://www.instagram.com/maderas.ferreterias.duran/"><i class="fab fa-instagram"></i></a>
              <a class="trans-150" target="_blank" href="https://www.youtube.com/channel/UCEIdqVwbZHNd7bqbIIIhr6A/featured"><i class="fab fa-youtube"></i></a>
            </p>
          </div>

          <div class="col-sm-6 col-lg col-footer col-r">
            <h6>Contáctanos</h6>

            <p>
              <router-link to="/tu-experiencia">Califica tu experiencia</router-link>
            </p>
            <p>
              <router-link to="/bolsa-de-trabajo">Bolsa de trabajo</router-link>
            </p>
            <p>
              <router-link to="/ubicaciones-y-sucursales">Ubicaciones</router-link>
            </p>
            <p>
              <router-link to="/facturacion-electronica">Facturación</router-link>
            </p>

            <p>
              <router-link to="/contacto">Contacto</router-link>
            </p>
          </div>

          <div class="col-sm-6 col-lg col-footer col-r">
            <h6>Ayuda</h6>

            <p>
              <router-link to="/nosotros">Nosotros</router-link>
            </p>
            <p>
              <router-link to="/metodos-de-pago">Métodos de pago</router-link>
            </p>
            <p>
              <router-link to="/aviso-de-privacidad">Aviso de Privacidad</router-link>
            </p>
            <p>
              <router-link to="/terminos-y-condiciones">Términos y Condiciones</router-link>
            </p>
            <p>
              <router-link to="/politica-de-devoluciones">Política de Devoluciones</router-link>
            </p>
            <p>
              <router-link to="/politica-de-envios-a-domicilio">Política de Envíos a Domicilio</router-link>
            </p>

            <!-- <p>
              <router-link to="">Preguntas Frecuentes</router-link>
            </p> -->
          </div>

          <!-- <div class="col-12 col-networks">
            <div class="d-block">
              <a class="trans-250 link" target="_blank" :href="info.facebook"><i class="fab fa-facebook-square"></i></a>
              <a class="trans-250 link" :href="info.instagram"><i class="fab fa-instagram"></i></a>
              <a class="trans-250 link" href="https://twitter.com/"><i class="fab fa-twitter-square"></i></a>
            </div>
          </div> -->

          <div class="col-12 col-payments">
            <hr />
            <h5 class="title" style="color: black !important;"> MADERAS Y FERRETERÍAS DURAN S. DE R.L. DE C.V. se reserva el derecho de cambio de precios, cambio en disponibilidad de inventarios, cambio en políticas de envío y cambio en políticas de devoluciones sin previo aviso.</h5>
            
            <br>
            <h5 class="title">Métodos de pago</h5>

            <img class="logos" src="public/images/pages/payments/logos.png">
          </div>
        </div>
      </div>
    </section>

  </footer>
</template>

<script>
export default {
  data(){
    return{
      form: {
        email: null
      },

      info: {
        telefono: '',
        email: '',
        facebook: '#',
        instagram: '#',
        youtube: '',
        address: 'Av. Diamante 2680.<br />Col. Bosques de la Victoria<br />Guadalajara, Jal.'
      }
    }
  },

  methods:{

    makeToast(variant = null, msg, title) {
        this.$bvToast.toast(msg, {
          title: title,
          variant: variant,
          solid: true,
          toaster: 'b-toaster-top-right',
          appendToast: true
        });
    },

    onSubmit(evt) {
      evt.preventDefault();
      var r = confirm("¿Deseas regístrate en newsletter? ");
      if (r == true) {
        axios.post(tools.url("/api/newsletter"), this.form).then((response)=>{
          this.makeToast('default', response.data.response, 'Gracias por registrar su correo '+this.form.email+'. Pronto recibirá en directo nuestras promociones y anuncios importantes en su bandeja de entrada');
          this.form = {
            name: null,
            email: null,
            msg: null,
            check: null
          };
        }).catch( (error)=> {
          // console.log(error.response);
          let errors = error.response.data;
          // console.log(errors);
          this.makeToast('danger', error.response.data.name, 'Error');
          this.makeToast('danger', error.response.data.email, 'Error');
          this.makeToast('danger', error.response.data.phone, 'Error');
          this.makeToast('danger', error.response.data.msg, 'Error');
        });
      }
    },

    getInfo: function(){
      axios.get(tools.url('/api/info')).then((response)=>{
        this.info = response.data;
      }).catch((error)=>{
        console.log(error);
      })
    }

  },

  beforeMount(){
    this.getInfo();
  }
}
</script>
